import { GuardStepResult } from "@rapid/hooks/useGuardStep";
import { Step } from "@rapid/types/flows";
import { useFlowState } from "../useFlowState";
import { useParams, useLocation } from "react-router-dom";
import { useCurrentMedia } from "@rapid/store";

export type UseGuardStep = (expectedStep: Step) => GuardStepResult;

export const useGuardBuildStep: UseGuardStep = (expectedStep) => {
    const { workspaceUrl } = useParams<{ workspaceUrl: string }>();
    const { step } = useFlowState();
    const currentMedia = useCurrentMedia();
    const location = useLocation();

    const redirectPath = workspaceUrl ? `/${workspaceUrl}` : "/";
    const redirectWithSearch = redirectPath + location.search;

    if (!currentMedia) {
        return {
            loading: false,
            step,
            passThrough: false,
            errors: [],
            redirect: redirectWithSearch
        };
    }

    const authorizedStep = step === expectedStep;
    if (authorizedStep) {
        return { loading: false, step, passThrough: true, errors: [] };
    }

    return {
        loading: false,
        step,
        passThrough: false,
        errors: [`[Guard Build Step] Invalid step - ${step}. Expected ${expectedStep}`],
        redirect: redirectWithSearch
    };
};
